import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { State } from 'src/app/app.reducer';
import { Observable } from 'rxjs';
import { Remarks } from 'src/app/core/models/remarks.model';
import * as fromReducers from '../selectors/remarks.selectors';
import * as remarksActions from '../actions/remarks.actions';
import { OptionType } from 'src/app/core/enums/enums';

@Injectable({
  providedIn: 'root'
})
export class RemarksService {
  constructor(private store: Store<State>) {}

  getRemarks(): Observable<Remarks> {
    return this.store.pipe(select(fromReducers.getRemarks));
  }

  getRemarkSavedOnProccess() {
    return this.store.pipe(select(fromReducers.getRemarkSavedOnProccess));
  }

  dispatchSaveRemarksFromComponent(remarksInfo: Remarks): void {
    return this.store.dispatch(remarksActions.SaveRemarksFromComponent({ remarksInfo }));
  }

  dispatchCreateRemarksFromComponent(
    remarksInfo: Remarks,
    pnr: string,
    savedFromProccess?: OptionType
  ): void {
    return this.store.dispatch(
      remarksActions.CreateRemarksFromComponent({ remarksInfo, pnr, savedFromProccess })
    );
  }
}
